<template>
  <div class="pos-relative">
    <transition name="fade">
      <div
          v-if="hasImages || sending"
          class="flex-0-1 bd-t-gray30 p-1 p-2:t">
        <div class="layout ov-scroll">
          <!-- <div
              v-for="(file, index) in newFiles"
              :key="index"
              class="layout-item flex-0-0">
            <div class="MESSAGE-IMAGE-LOADING">
              <spinner />
            </div>
          </div> -->
          <gallery :files="newFiles" deletable @deleteImage="onFileDelete"/>
        </div>
      </div>
    </transition>

    <div class="flex-0-1 bd-t-gray30 p-1 p-2:t">
      <div class="layout gap-1 gap-2:t flex-center">
        <input
            ref="galleryInput"
            :disabled="messageDisabled"
            accept="image/*"
            multiple
            type="file"
            class="d-none"
            @change="onNewFilesUpload"
            selenium="messages-attach-gallery"
        />
        <input
            ref="cameraInput"
            :disabled="messageDisabled"
            accept="image/*"
            capture="environment"
            type="file"
            class="d-none"
            @change="onNewFilesUpload"
            selenium="messages-attach-camera"
        />
        <button
            v-tooltip="'Add Pictures'"
            type="button"
            @click="onAddPhotoClick"
            style="background: none; border: none; padding: 0; margin: 0;"
        >
          <vk-icon name="add-a-photo" class="MESSAGE-UPLOAD-INPUT-ICON"/>
        </button>
        <div class="MESSAGE-INPUT-WRAPPER layout-item input-container" static>
          <textarea
              v-auto-expand
              ref="message-input"
              :disabled="messageDisabled"
              v-model.trim="message"
              class="input d-block w-100"
              name="message"
              rows="1"
              placeholder="Type your message"
              maxlength="1024"
              selenium="message-input"
          />
        </div>
        <div class="layout-item d-flex ai-center flex-0-0">
          <button
              :disabled="!isSendable"
              class="btn w-100"
              selenium="message-send-button"
              @click="sendMessage">
            <loading-indicator v-if="sending" :size="16" />
            <span v-else>Send</span>
          </button>
        </div>
        <vk-modal class="gallery-popup-overlay" v-if="showGalleryPopup" @close="closeGalleryPopup">
          <div class="gallery-popup">
            <div class="popup-content">
              <h3>Select Images</h3>
              <button
                  class="BUTTON"
                  @click="() => { this.$refs.galleryInput.click(); closeGalleryPopup(); }"
              >
                Choose from Gallery
              </button>
              <button class="BUTTON" @click="openCamera">Capture from Camera</button>
              <button class="BUTTONCLOSE" @click="closeGalleryPopup">Close</button>
            </div>
          </div>
        </vk-modal>
      </div>
    </div>
    <div
        v-if="isUploading"
        class="UPLOAD-LOADER-OVERLAY"
        selenium="messages-upload-loader">
      <loading-indicator :size="64" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import PRUtils from '@homeservices/tool-kit/proreferral/utils';
import { VALID_IMAGE_ACCEPT_TYPES } from '@/constants';
import files from '@/mixins/job/files';

export default {
  name: '',
  components: {},
  mixins: [
    files,
  ],
  props: {
    job: {
      type: Object,
      required: true,
    },
    skillsProfileId: {
      type: Number,
      required: true,
    },
  },
  data () {
    return {
      newFiles: [],
      message: '',
      fileIds: [],
      loadingFiles: [],
      sending: false,
      isUploading: false,
      imageSent: false,
      showGalleryPopup: false,
    };
  },
  computed: {
    ...mapGetters('consumer/files', ['files']),
    isAndroid () {
      return /Android/i.test(navigator.userAgent);
    },
    match () {
      return this.job.matches.find(matchElement =>
        matchElement.service_provider_id === this.skillsProfileId);
    },
    messageDisabled () {
      // No matching pro for this conversation: treat as unavailable instead of crashing
      return !this.match || PRUtils.messages.shouldBeDisabled(this.match.match_status);
    },
    isSendable () {
      return !this.sending && !this.messageDisabled && (this.message || this.newFiles.length);
    },
    uploadedFiles () {
      return this.newFiles.map(url => this.newFiles[url]);
    },
    hasImages () {
      return this.newFiles.length;
    },
  },
  methods: {
    onAddPhotoClick () {
      if (this.isAndroid) {
        this.showGalleryPopup = true;
      } else {
        this.$refs.galleryInput.click();
      }
    },
    openCamera () {
      this.$refs.cameraInput.click();
    },
    closeGalleryPopup () {
      this.showGalleryPopup = false;
    },
    async sendMessage () {
      if (this.sending) { return; }

      this.$emit('message-sending');
      this.sending = true;
      this.imageSent = true;

      try {
        await this.$store.dispatch('consumer/messages/sendMessage', {
          jobId: this.job.order_hash,
          service_provider_id: this.skillsProfileId,
          message: this.message,
          asset_urls: this.newFiles.map(({ url }) => url),
        });

        this.$emit('message-sent');
        this.messageTransition = 'list';
        this.message = '';
        this.fileIds = [];
        this.newFiles = [];
        this.loadingFiles = [];
      } finally {
        this.sending = false;
        this.$emit('message-send-finished');
      }
    },
    async uploadFile (file) {
      const body = new FormData();
      body.append('file', file);

      const data = await this.createFiles({
        jobId: this.job.order_hash,
        skillsProfile: this.serviceProviderId,
        body,
      });
      this.newFiles = [...this.newFiles, data];
    },
    async onNewFilesUpload ({ target }) {
      this.isUploading = true;
      this.showGalleryPopup = false;

      try {
        await Promise.all(Array.from(target.files).map(this.uploadFile));
      // eslint-disable-next-line no-empty
      } catch (error) {} finally {
        this.isUploading = false;
      }
    },
    async onFileDelete (fileId) {
      await this.deleteFiles({
        jobId: this.job.order_hash,
        skillsProfile: this.serviceProviderId,
        fileId,
      });
      this.newFiles = this.newFiles.filter(({ id }) => id !== fileId);
    },
  },
  VALID_IMAGE_ACCEPT_TYPES,
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools.scss";

  .BLOCKER {
    @include absolute(0, 0, 0, 0);
    display: flex;
    align-items: center;
    justify-content: center;
    color: rgba(white, 0.75);
    text-align: center;
    user-select: none;
    z-index: 1;
    background: rgba(black, .8);
    cursor: not-allowed;
  }

  .MESSAGE-INPUT-WRAPPER {
    @include margin-top(0, $important: true);
    z-index: 0;
  }

  .MESSAGE-IMAGE-LOADING {
    @include margin-right(1);
    @include unit(width height, 6, 10);
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: $color-gray80;
  }

  .MESSAGE-UPLOAD-INPUT {
    @include absolute(0, 0, 0, 0);
    opacity: 0;
    cursor: pointer;

    &:disabled {
      cursor: not-allowed;
    }
  }

  .MESSAGE-UPLOAD-INPUT-ICON {
    @include h2();
    transition: color 0.1s;
    color: rgba($color-depot, 1);


    .MESSAGE-UPLOAD-INPUT:hover + & {
      color: $color-depot;
    }

    .MESSAGE-UPLOAD-INPUT:disabled + & {
      color: $color-gray40;
    }
  }
  .gallery-popup-overlay {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}
.gallery-popup {
  background: #fff;
  padding: 24px;
  border-radius: 8px;
  min-width: 240px;
  text-align: center;
}
  .popup-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
  }
  .BUTTON {
    border: 1px solid $color-depot;
    line-height: 22px;
    color: #fff;
    background-color: $color-depot;
    border-radius: 3px;
    height: 28px;
    .TEXT {
      font-size: 14px;
    }
  }
    .BUTTONCLOSE {
    border: 1px solid $color-depot;
    line-height: 22px;
    color: $color-depot;
    background-color: white;
    border-radius: 3px;
    height: 28px;
    .TEXT {
      font-size: 14px;
    }
  }

  .UPLOAD-LOADER-OVERLAY {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.7);
    z-index: 10000;
  }


</style>
